import React from 'react';
import { useLingui } from '@lingui/react/macro';

import { BlueByteLogoWrapper, SiderLogoDiv, SiderPoweredBy, SmallBlueByteLogoWrapper } from './styled.ts';

interface Props {
    collapsed: boolean;
}
export const SiderLogo: React.FC<Props> = ({ collapsed }) => {
    const { t } = useLingui();

    return (
        <SiderLogoDiv>
            {collapsed ? (
                <SmallBlueByteLogoWrapper />
            ) : (
                <>
                    <SiderPoweredBy>{t`Powered by`}</SiderPoweredBy>
                    <BlueByteLogoWrapper />
                </>
            )}
        </SiderLogoDiv>
    );
};
